import { UiState, UiStateEnum } from "./UiState";
import { ActionStateEnum } from "../actionState/ActionState";
import { Utils } from "../../utils/Utils";
import { PlanManager } from "../../../../cocosPlan";
import { FrontViewCoating } from "../actionState/FrontViewCoating";
import { CoatingArea, ComponentConstants, math, SavaneConstants, SavaneMath, Segment } from "@rhinov/savane-js";

export class UiFrontViewState extends UiState {

    limitPoint = math.vec3.create();
    floorHeight = PlanManager.getInstance().frontViewLayer.computeFloorHeight();

    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3) {
        super(cursorPosition, cocosPosition);
        
        var currentWall = PlanManager.getInstance().frontViewLayer.currentWall!;
        math.vec3.set(this.limitPoint, currentWall.length, 0, currentWall.height);
    }

    getUiState(): number {
        return UiStateEnum.UiFrontView;
    }

    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;
        this.setSelected();
        return null;
    }

    setSelected() {
        var planManager = PlanManager.getInstance();
        var wall = planManager.frontViewLayer.currentWall!;
        var isDirectFace = planManager.frontViewLayer.isDirectSide;
        var obj = planManager.world.currentScene!.currentFloor!.getWallDecorationAtPosition(wall.id, isDirectFace, this.cursorPosition, 5 * SavaneConstants.PositionTolerance);
        this.hoverEntities = obj === null ? [] : [obj];

        //update wall length extended by adjacent wall thickness
        /*this.limitPoint[0] = PlanManager.getInstance().frontViewLayer.computeWallLength();

        this.cocosPosition[0] = this.cocosPosition[0] < 0 ? 0 :
            this.cocosPosition[0] > this.limitPoint[0] ? this.limitPoint[0] :
                this.cocosPosition[0];
        this.cocosPosition[2] = this.cocosPosition[2] < this.floorHeight ? this.floorHeight :
            this.cocosPosition[2] > this.limitPoint[2] ? this.limitPoint[2] :
                this.cocosPosition[2];*/


        if (planManager.getAction() === ActionStateEnum.FrontViewCoating && planManager.snapEnabled) {
            //snap 90° and on others coatings
            var areaCoatings = wall.getComponents(ComponentConstants.ComponentType.CoatingArea) as CoatingArea[];
            var i, j,
                testPosition = math.vec3.clone(this.cursorPosition),
                res = math.vec3.clone(this.cursorPosition),
                segment = new Segment(math.vec3.create(), math.vec3.create()),
                magnetOnVertex = false,
                magnetOnSegment = null;
            testPosition[1] = testPosition[2];
            testPosition[2] = 0;
            res[1] = res[2];
            res[2] = 0;

            //magnet on coating
            for (i = 0; i < areaCoatings.length; ++i) {
                if (areaCoatings[i].isDirectSide === isDirectFace &&
                    areaCoatings[i].id !== (planManager.state as FrontViewCoating)._area!.id) {

                    for (j = 0; j < areaCoatings[i].vertices.length; j++) {
                        //magnet on vertex
                        if (math.vec3.dist(areaCoatings[i].vertices[j], testPosition) < Utils.magnetDistance) {
                            magnetOnVertex = true;
                            magnetOnSegment = null;
                            math.vec3.copy(res, areaCoatings[i].vertices[j]);
                            break;
                        }


                        //magnet on edge
                        segment.begin = areaCoatings[i].vertices[j];
                        segment.end = areaCoatings[i].vertices[(j + 1) % areaCoatings[i].vertices.length];
                        if (segment.isPointOnSegment(testPosition, Utils.magnetDistance)) {
                            math.vec3.copy(res, segment.orthogonalProjection(testPosition)!);
                            magnetOnSegment = new Segment(segment.begin, segment.end);
                        }
                    }
                }
            }

            //angle magnet
            var firstPoint = (planManager.state as FrontViewCoating).beginPoint;
            var lastSegment = (planManager.state as FrontViewCoating).lastSegment;
            if (firstPoint !== null && lastSegment !== null && !magnetOnVertex) {
                var editedSegment = new Segment(firstPoint, res);

                var dist = editedSegment.length;
                var ratio = 2500 / dist > 1 ? 2500 / dist : 1;
                if (dist > 100 && Math.abs(math.vec3.dot(editedSegment.direction, lastSegment.direction)) < Utils.angleMagnet * ratio) {
                    if (magnetOnSegment === null) {
                        if (editedSegment.direction[0] < 0) {
                            res[0] = -Math.abs(lastSegment.direction[1]) * dist + editedSegment.begin[0];
                        } else {
                            res[0] = Math.abs(lastSegment.direction[1]) * dist + editedSegment.begin[0];
                        }
                        if (editedSegment.direction[1] < 0) {
                            res[1] = -Math.abs(lastSegment.direction[0]) * dist + editedSegment.begin[1];
                        } else {
                            res[1] = Math.abs(lastSegment.direction[0]) * dist + editedSegment.begin[1];
                        }
                    } else {
                        var lastPoint = math.vec3.clone(firstPoint);
                        lastPoint[0] += -(lastSegment.direction[1]) * dist;
                        lastPoint[1] += (lastSegment.direction[0]) * dist;
                        var snapPoint = SavaneMath.getCrossPoint(magnetOnSegment.begin, magnetOnSegment.end, firstPoint, lastPoint);
                        if (snapPoint !== null && math.vec3.distance(snapPoint, firstPoint) > SavaneConstants.PositionTolerance) {
                            res = snapPoint;
                        }
                    }
                }
            }

            res[2] = res[1];
            res[1] = 0;
            this.cursorPosition = res;
        }
    }
}
